// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"520":"4a8cf796","636":"90e876bf","680":"17c7807e","865":"429173e6"}[chunkId] + ".js";
};